<template>
  <div>
    <table-widget :items="notes" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage" :filter.sync="filter">
      <template slot="buttons">
        <b-button v-b-modal.notes-modal class="ml-2" variant="primary"><font-awesome-icon icon="plus"/>Add Note</b-button>
      </template>
      <template slot="content">
        <b-table striped
                :items="selectedNotes"
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                @filtered="onFiltered"
                small
                show-empty
                :tbody-transition-props="transProps"
                empty-filtered-text="There are no files that match your search criteria.">
          
          <template v-slot:cell(createdDate)="data">
            {{ data.item.createdDate | formatDateTime }}
          </template>
        </b-table>
      </template>
    </table-widget>
    
    <b-modal id="notes-modal" title="Add Note" @ok="addNote">
      <b-form-textarea v-model="noteText" placeholder="Notes" rows="3"></b-form-textarea>
    </b-modal>
  </div>
</template>

<script>
import TableWidget from "../table-widget";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      transProps: {
        // Transition name
        name: "fade"
      },
      selectedNotes: [],
      fields: [
        { key: "notes", label: "Notes" },
        { key: "createdBy", label: "Added By" },
        { key: "createdDate", label: "Date" }
      ],
      noteText: "",
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      selectedFiles: [],
      maxFiles: 5,
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" }
    };
  },

  props: {
    notes: {
      type: Array,
      required: true,
      default: function() {
        return [];
      }
    }
  },

  components: { "table-widget": TableWidget },

  computed: {},

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    addNote: function() {
      // add files to file array
      var that = this;
      that.$emit("noteAdded", { notes: this.noteText });
      that.file = null;
    }
  },

  watch: {
    notes: function() {
      if (this.notes.length) {
        this.selectedNotes = this.notes;
        this.totalRows = this.notes.length;
      }
    }
  },

  created() {
    if (this.notes.length) {
      this.selectedNotes = this.notes;
      this.totalRows = this.notes.length;
    }
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
